import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Z5() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div className={`d2x-Z5 ${css.d2xZ5} GtmModuleData-section`} data-section-id={css.d2xZ5} data-section-title={t('sec5_title')}>
            <div className="sec5">
                <div className="text-box">
                    <p className="title">{t('sec5_title')}</p>
                    <p className="desc">{t('sec5_desc')}</p>
                </div>
                <div className="img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z5.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z5.jpg')}
                        alt={t('sec5_title')}
                        aria-label={t('sec5_title')}
                    />
                </div>
            </div>
        </div>
    );
}
